import { render, staticRenderFns } from "./WebPush.vue?vue&type=template&id=38fec2c1&"
import script from "./WebPush.vue?vue&type=script&lang=ts&"
export * from "./WebPush.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports